export const ADLOGS_SUB_SERVICES = [
    { key: 'blitz', tabId: 'blitz-rider', label: 'Blitz Riders', name: 'Blitz' },
    { key: 'borzo', tabId: 'borzo-rider', label: 'Borzo Riders', name: 'Borzo' },
    { key: 'ek_bharat', tabId: 'ek-bharat-rider', label: 'Ek Bharat Riders', name: 'Ek Bharat' },
    { key: 'load_share', tabId: 'load-share-rider', label: 'LoadShare Riders', name: 'LoadShare' },
    { key: 'magicpin', tabId: 'magicpin-rider', label: 'MagicPin Riders', name: 'MagicPin' },
    { key: 'ondc', tabId: 'ondc-rider', label: 'ONDC Riders', name: 'ONDC' },
    { key: 'qwqer', tabId: 'qwqer-rider', label: 'Qwqer Riders', name: 'Qwqer' },
    { key: 'rapido', tabId: 'rapido-rider', label: 'Rapido Riders', name: 'Rapido' },
    { key: 'shadowfax', tabId: 'adlogs-shadowfax-rider', label: 'Shadowfax (Adlogs) Riders', name: 'Shadowfax (Adlogs)' },
    { key: 'ship_rocket', tabId: 'ship-rocket-rider', label: 'ShipRocket Riders', name: 'ShipRocket' },
    { key: 'yullu', tabId: 'yullu-rider', label: 'Yullu Riders', name: 'Yullu' },
];

// The order details payload returns one object per sub-service: adlogs_<key>_order.
// Returns the service descriptor for whichever sub-service order is present, or null.
export const getActiveAdlogsService = (order) =>
    ADLOGS_SUB_SERVICES.find((svc) => order?.[`adlogs_${svc.key}_order`]) || null;
